import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=a782ee92"
import script from "./IconGlobe.vue?vue&type=script&lang=js"
export * from "./IconGlobe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports